import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ACLService } from '@delon/acl';

@Component({
  selector: 'app-tiktok',
  templateUrl: './tiktok.component.html',
  styles: [],
})
export class CommentTiktokComponent implements OnInit {
  menus: any[] = [];
  private router$: Subscription;
  mode = 'inline';
  title: string;
  queryParams = {
    tabs: [],
    isInner: '0',
    channelId: '',
    channelName: '',
    msgType: '',
    type: 'keyword',
    title: '',
  };

  constructor(
    private _activatedroute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    private aclService: ACLService
  ) {}

  // 自定义组件名
  static NAME = 'icc-msg-comment';

  changeMsgType(msgType: any) {
    this.menus.forEach((item) => {
      item.selected = item.key === msgType.key;
    });
    sessionStorage.setItem('msgTypeKey', msgType.key);
    this.router.navigateByUrl(`/msgRecord/comment/tiktok/${msgType.key}`);
  }

  initMenu() {
    let key = this.router.url.substr(this.router.url.lastIndexOf('/') + 1);
    let keys = key.split('?');
    if (keys.length > 1) {
      key = keys[0];
    }
    if (this.aclService.canAbility('patchAudit.audit')) {
      this.menus.push({
        key: 'message',
        title: '私信',
        selected: key === 'message',
      });
    }
    if (this.aclService.canAbility('patchAudit.audited')) {
      this.menus.push({
        key: 'comment',
        title: '评论',
        selected: key === 'comment',
      });
    }
  }

  ngOnInit() {
    this.initMenu();
  }
}
